"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfig = exports.getByBrand = exports.getByUrlBeta = exports.getByUrlPart = exports.getByUrl = void 0;

var config_json_1 = __importDefault(require("./config.json"));

exports.getByUrl = function (_a) {
  var url = _a.url,
      type = _a.type;
  var res = {};

  for (var theme in config_json_1.default) {
    var _b = theme,
        tsmePart = _b.tsmePart,
        tsmeBeta = _b.tsmeBeta;
    if (type === 'beta' && tsmeBeta === url) res = theme;
    if (type === 'part' && tsmePart === url) res = theme;
  }

  return res;
};

exports.getByUrlPart = function (url) {
  return exports.getByUrl({
    url: url,
    type: 'part'
  });
};

exports.getByUrlBeta = function (url) {
  return exports.getByUrl({
    url: url,
    type: 'beta'
  });
};

exports.getByBrand = function (brand) {
  return config_json_1.default[brand];
};

exports.useConfig = function (options) {
  if (typeof options === 'object') return exports.getByUrl(options);
  if (typeof options === 'string') return exports.getByBrand(options);
};

exports.default = exports.useConfig;